module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07441_logo_200x200.e7b7d624.png";